import { render } from "./Attribution.vue?vue&type=template&id=1527498c"
import script from "./Attribution.vue?vue&type=script&lang=js"
export * from "./Attribution.vue?vue&type=script&lang=js"

import exportComponent from "/Users/admin/#_Projects/vegeta/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__